import { NavLink, Route, Routes } from 'react-router-dom';
import { SignedIn, SignedOut, SignIn, UserButton, useOrganization } from '@clerk/clerk-react';
import Dashboard from './pages/Dashboard';
import Clients from './pages/Clients';
import ClientDetail from './pages/ClientDetail';
import Reminders from './pages/Reminders';
import Exports from './pages/Exports';
import Settings from './pages/Settings';
import Billing from './pages/Billing';
import Invoices from './pages/Invoices';
import Marketplace from './pages/Marketplace';
import Import from './pages/Import';
import Team from './pages/Team';

export default function App() {
  return (
    <>
      <SignedOut>
        <div style={{ display: 'grid', placeItems: 'center', minHeight: '100vh' }}>
          <SignIn routing="hash" />
        </div>
      </SignedOut>
      <SignedIn>
        <Shell />
      </SignedIn>
    </>
  );
}

function Shell() {
  const { organization } = useOrganization();
  return (
    <div className="shell">
      <nav>
        <div className="brand">TagVault</div>
        <NavLink to="/" end>Due work</NavLink>
        <NavLink to="/clients">Clients</NavLink>
        <NavLink to="/reminders">Reminders</NavLink>
        <NavLink to="/import">Import</NavLink>
        <NavLink to="/exports">Exports</NavLink>
        <NavLink to="/team">Team</NavLink>
        <NavLink to="/invoices">Invoices</NavLink>
        <NavLink to="/billing">Billing</NavLink>
        <NavLink to="/marketplace">My round</NavLink>
        <NavLink to="/settings">Settings</NavLink>
        <div className="org">
          {organization?.name ?? 'No organisation'}
          <div style={{ marginTop: '.5rem' }}><UserButton /></div>
        </div>
      </nav>
      <main>
        <Routes>
          <Route path="/" element={<Dashboard />} />
          <Route path="/clients" element={<Clients />} />
          <Route path="/clients/:clientId" element={<ClientDetail />} />
          <Route path="/reminders" element={<Reminders />} />
          <Route path="/import" element={<Import />} />
          <Route path="/exports" element={<Exports />} />
          <Route path="/team" element={<Team />} />
          <Route path="/invoices" element={<Invoices />} />
          <Route path="/billing" element={<Billing />} />
          <Route path="/marketplace" element={<Marketplace />} />
          <Route path="/settings" element={<Settings />} />
        </Routes>
      </main>
    </div>
  );
}
